.page {
  background: #ffffff;
  width: 100%;
}

.layout {
  min-height: calc(100vh - 115px);
  width: 100%;
}

.contentColumn {
  flex: 0 0 500px;
  padding: 50px 0;
  background: #ffffff;
}

.contentInner {
  padding: 20px 40px;
}

.heading {
  color: #3caeb0;
  font-size: 50px;
  font-weight: 700;
  line-height: 1.08;
  margin: 0 0 28px;
  letter-spacing: 0;
}

.copy {
  margin-bottom: 64px;
}

.copy p {
  color: #111111;
  font-size: 16px;
  line-height: 1.35;
  margin: 0;
  letter-spacing: 0;
}

.form {
  display: flex;
  flex-direction: column;
  gap: 28px;
  width: 100%;
}

.input {
  box-sizing: border-box;
  width: 100%;
  height: 45px;
  border: 1px solid #d7d7d7;
  border-radius: 0;
  background: #ffffff;
  color: #222325;
  font: 300 16px/45px "Poppins", sans-serif;
  padding: 0 0.6em;
  outline: none;
  transition: border-color 0.33s ease-in-out;
}

.input:focus {
  border-color: #222325;
}

.input::placeholder {
  color: #a6a8ad;
  opacity: 1;
}

.submit {
  box-sizing: border-box;
  align-self: flex-start;
  width: auto;
  height: 50px;
  border: 0;
  border-radius: 0;
  background: #ffa489;
  color: #ffffff;
  cursor: pointer;
  font: 700 15px/50px "Poppins", sans-serif;
  letter-spacing: 2px;
  padding: 0 38px;
  text-align: center;
  text-transform: uppercase;
  transition:
    background-color 0.33s ease-in-out,
    color 0.33s ease-in-out,
    box-shadow 0.33s ease-in-out;
}

.submit:hover {
  background: #ffffff;
  color: #000000;
  box-shadow: 0 0 24px rgba(0, 0, 0, 0.15);
}

.imageColumn {
  flex: 1 1 calc(100% - 500px);
  min-height: calc(100vh - 115px);
  background-image: image-set(
    url("/optimized/kids-club-carmen-gracia-2019-1170.webp") type("image/webp"),
    url("/kids-club-carmen-gracia-2019.jpg") type("image/jpeg")
  );
  background-attachment: fixed;
  background-position: left center;
  background-repeat: no-repeat;
  background-size: cover;
}

.srOnly {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

@media (max-width: 768px) {
  .layout {
    display: block;
    min-height: 0;
  }

  .contentColumn {
    width: 100%;
    padding: 25px 0 54px;
  }

  .contentInner {
    padding: 20px;
  }

  .heading {
    font-size: 32px;
    line-height: 1.05;
    margin-bottom: 28px;
  }

  .copy {
    gap: 28px;
    margin-bottom: 66px;
  }

  .copy p {
    font-size: 16px;
    line-height: 1.28;
  }

  .form {
    gap: 28px;
  }

  .submit {
    height: 50px;
    font-size: 14px;
    line-height: 50px;
    padding: 0 25px;
  }

  .imageColumn {
    display: none;
  }
}

@media (max-width: 640px) {
  .submit {
    width: 100%;
  }
}
